module.exports = __webpack_public_path__ + "static/img/logos_move.a2c26930.png";